import { TaskTypeService } from '../shared/task-type.service';
import { ProfileService } from '../../profiles/shared/profile.service';
import { UserRead } from '../../users/shared/user-read.model';
import { SelectItem } from 'primeng/api';
import { UserService } from '../../users/shared/user.service';
import { TaskDto } from '../shared/dto/task.dto';
import { ProfileMin } from '../../profiles/shared/profile-min.model';
import { Component, OnInit, Input, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ProfileRead } from 'src/app/profiles/shared/profile-read.model';
import { TaskTypeSearchDto } from '../shared/dto/task-type-search.dto';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-task-edit',
  templateUrl: './task-edit.component.html',
  styleUrls: ['./task-edit.component.less'],
  encapsulation: ViewEncapsulation.None,
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class TaskEditComponent implements OnInit {
  // @Input() task: TaskDto;
  @Input()
  get task() {
    return this._task;
  }
  set task(value: TaskDto) {
    this._task = value;
    if (value?.ProfileID) {
      this.loadProfile(value.ProfileID);
    }
    this.setDefaultProperties();
    this.taskChange.emit(this._task);
  }
  @Input() allowProfileAssignment = true;
  @Output() taskChange = new EventEmitter<TaskDto>();

  profile: ProfileRead;
  currentUser: UserRead;
  userSelectItems: SelectItem[] = [];
  taskTypeItems: SelectItem[] = [];
  private users: Array<UserRead>;

  private _task: TaskDto;
  constructor(private _userService: UserService, private _profileService: ProfileService, private _taskTypeService: TaskTypeService) {}

  ngOnInit(): void {
    this._userService.getActiveUsers().then((users) => {
      this.users = users;
      this.userSelectItems = users.map<SelectItem>((user) => {
        return { label: user.UserName, value: user.UserNum };
      });
      this.userSelectItems.sort((a, b) => a.label.localeCompare(b.label));
    });

    this._userService.getCurrentUser().then((user) => {
      this.currentUser = user;
    });

    this._taskTypeService
      .search({
        PageSize: 0,
        PageNumber: 0,
        OrderBy: '',
      } as TaskTypeSearchDto)
      .then((result) => {
        this.taskTypeItems = result.Result?.map<SelectItem>((taskType) => {
          return { label: taskType.TaskType1, value: taskType.TaskType1 };
        });
      });
  }

  completedChanged() {
    if (this.task.Closed) {
      this.task.DateClosed = new Date();
    }
  }

  assignmentChanged() {
    if (!this._task.TaskId && this.task.AssignedBy != this.task.UserNum) {
      this.task.NotifyWhenComplete = this.users.find((x) => x.UserNum == this.task.AssignedBy)?.Email;
    }
  }

  private loadProfile(profileId: number) {
    this._profileService.getProfile(profileId).then((profile) => {
      this.profile = profile;
      this._profileService.getMemberIconColor(profileId).then((color) => {
        this.profile.MemberTypeIconColor = color;
      });
    });
  }

  private setDefaultProperties() {
    if (!this.task) {
      return;
    }

    if (!this.task.TaskId) {
      this.task.ProfileID = this.task.ProfileID ?? 0;
      this.task.AssignedBy = this.currentUser?.UserNum;
      this.task.UserNum = this.currentUser?.UserNum;
    }
  }
}
